import React from 'react';
import SvgIcon from './SvgIcon';

const ExpandVertical = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M17 12.499H7.5M12 23.499v-8M9 20.499l3 3 3-3M12 .499v8M9 3.499l3-3 3 3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

ExpandVertical.displayName = 'ExpandVerticalIcon';

export default ExpandVertical;
